var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('CrmLeadReminderListUi',{attrs:{"items":_vm.rows,"draft":_vm.draft,"saving":_vm.saving},on:{"add":_vm.add,"edit":_vm.edit,"cancel":_vm.cancel,"save":_vm.save,"remove":_vm.remove}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }